import { createSlice } from '@reduxjs/toolkit';
import AbstractSliceHandler from 'modules/shared/stores/abstract-slice-handler';
import Log from 'utils/log';

/**
 * @type {Object}
 */
const initialState = {
    /**
     * The master page which is currently active.
     * @type {MainMenuItemType|null}
     */
    activePage: null,
    /**
     * This is a TEMPORARY property which describes the height of the space occupied by the banners of the calls and channels.
     * This property should be removed from here once the banners system will be integrated inder WCFUI.
     * @type {number}
     */
    bannersSpaceHeight: 0,
};

class MasterPagesSliceHandler extends AbstractSliceHandler {
    static getInstance() {
        if (!MasterPagesSliceHandler.instance) {
            MasterPagesSliceHandler.instance = new MasterPagesSliceHandler();
        }

        return MasterPagesSliceHandler.instance;
    }

    constructor() {
        super('masterPagesSlice');

        this.slice = createSlice({
            name: this.sliceName,
            initialState,
            reducers: {
                /**
                 * Register a portal.
                 * @param {object} state
                 * @param {{payload: MainMenuItemType|null}} action
                 */
                setActivePage(state, action) {
                    const currentPage = state.activePage;

                    if (currentPage === action.payload) {
                        return;
                    }

                    state.activePage = action.payload;

                    Log.debug(
                        'MASTER PAGES STORE',
                        `Changing the active page from ${currentPage} to ${action.payload}.`,
                    );
                },
                /**
                 * Set the height of the call/channel banners.
                 * @param {object} state
                 * @param {{payload: number}} action
                 */
                setBannersSpaceHeight(state, action) {
                    const currentHeight = state.bannersSpaceHeight;

                    state.bannersSpaceHeight = action.payload;

                    Log.debug(
                        'MASTER PAGES STORE',
                        `Changing the banners space height from ${currentHeight}px to ${action.payload}px.`,
                    );
                },
            },
        });
    }

    /**
     * Set the current active page.
     * @param {MainMenuItemType} activePage
     */
    setActivePage = (activePage) => {
        this.dispatch('setActivePage', activePage);
    };

    /**
     * Set the current height of the call/channels banners space.
     * @param {number} bannersSpaceHeight
     */
    setBannersSpaceHeight = (bannersSpaceHeight) => {
        this.dispatch('setBannersSpaceHeight', bannersSpaceHeight);
    };
}

// the handler
export const masterPagesSliceHandler = MasterPagesSliceHandler.getInstance();
// the selectors to be used in useSelect
export const selectActivePage = (state) => state.masterPagesSlice.activePage;
export const selectBannersSpaceHeight = (state) => state.masterPagesSlice.bannersSpaceHeight;
export const { setActivePage, setBannersSpaceHeight } = masterPagesSliceHandler;
